import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue"),
  },
  {
    path: "/fullScreenMonitor",
    name: "",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/Monitor/OperationMonitor/OperationMonitor.vue"
      ),
  },
  {
    path: "/home",
    // redirect: {
    //   name: "home",
    // },
    component: Home,
    children: [
      {
        path: "/DevopsGroup",
        name: "/DevopsGroup",
        component: () => import("../views/Devops/DevopsDept/DevopsGroup.vue"),
      },
      {
        path: "/AddOrder",
        name: "",
        component: () => import("../views/WorkOrder/Dispatch/AddOrder.vue"),
      },
      {
        path: "/TransferOrder/:id",
        name: "",
        component: () =>
          import("../views/WorkOrder/Dispatch/TransferOrder.vue"),
      },
      {
        path: "/AddFence",
        name: "",
        component: () => import("../views/Vehicle/FenceManage/AddFence.vue"),
      },
      {
        path: "/Dispatch",
        name: "Dispatch",
        component: () => import("../views/WorkOrder/Dispatch/Dispatch.vue"),
      },
      {
        path: "/Audit",
        name: "Audit",
        component: () =>
          import("../views/BaseStationManage/PathAudit/Audit.vue"),
      },
      {
        path: "/Vehicle",
        name: "Vehicle",
        component: () =>
          import("../views/Vehicle/VehicleManage/VehicleManagement.vue"),
      },
      {
        path: "/VehicleInfo",
        name: "VehicleInfo",
        component: () =>
          import("../views/Vehicle/VehicleManage/VehicleInfo.vue"),
      },
      {
        path: "/AddNotice",
        name: "AddNotice",
        component: () =>
          import("../views/Vehicle/CustomNotice/components/AddNotice.vue"),
      },
      {
        path: "/PowerRecordDetail",
        name: "PowerRecordDetail",
        component: () =>
          import(
            "../views/Vehicle/VehicleManage/components/power/PowerDetail.vue"
          ),
      },
      {
        path: "/AlarmDetails",
        name: "AlarmDetails",
        component: () =>
          import(
            "../views/Vehicle/VehicleManage/components/alarm/AlarmDetails.vue"
          ),
      },
      {
        path: "/AuthorityManage",
        name: "AuthorityManage",
        component: () =>
          import("../views/AuctionSystem/AuthorityManage/AuthorityManage.vue"),
      },
      {
        path: "/UserManage",
        name: "UserManage",
        component: () =>
          import("../views/AuctionSystem/UserManage/UserManage.vue"),
      },
      {
        path: "/PointPositionManage",
        name: "PointPositionManage",
        component: () =>
          import("../views/PointPositionManage/PointPositionManage.vue"),
      },
      {
        path: "/PercentManagement",
        name: "PercentManagement",
        component: () =>
          import("../views/OtherServices/PercentManagement/PercentManagement.vue"),
      },
      {
        path: "/UnitManagement",
        name: "UnitManagement",
        component: () => import("../views/UnitManagement/UnitManagement.vue"),
      },
      {
        path: "/desktop",
        name: "",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/DeskTop.vue"),
      },
      {
        path: "/AlarmMonitor",
        name: "AlarmMonitor",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/Monitor/AlarmMonitor/AlarmMonitor.vue"
          ),
      },
      {
        path: "/HistoryAlarm",
        name: "HistoryAlarm",
        component: () =>
          import("../views/Monitor/AlarmMonitor/components/HistoryAlarm.vue"),
      },
      {
        path: "/AlarmSet",
        name: "AlarmSet",
        component: () => import("../views/Monitor/AlarmSet/AlarmSet.vue"),
      },
      {
        path: "/BaseStationPowerRecord",
        name: "BaseStationPowerRecord",
        component: () =>
          import(
            "../views/Statistics/BaseStationPowerRecord/BaseStationPowerRecord.vue"
          ),
      },
      {
        path: "/PowerRecordMore",
        name: "PowerRecordMore",
        component: () =>
          import(
            "../views/Statistics/BaseStationPowerRecord/components/PowerRecordMore.vue"
          ),
      },
      {
        path: "/PowerDetail",
        name: "PowerDetail",
        component: () =>
          import(
            "../views/Statistics/BaseStationPowerRecord/components/PowerDetail.vue"
          ),
      },
    ],
  },
  {
    path: "*",
    name: "",
    component: () => import("../views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
